import React, { useState } from "react";
import {
    Box,
    Button,
    Heading,
    Input,
    Text,
    VStack,
    useToast,
} from "@chakra-ui/react";
import {
    CollectionPin,
    useVerifyCollectionPinMutation,
} from "./pinManagementApi";

const PinVerificationPage: React.FC = () => {
    const toast = useToast();
    const [code, setCode] = useState("");
    const [verifiedPin, setVerifiedPin] = useState<CollectionPin | null>(null);

    const [verifyPin, { isLoading }] = useVerifyCollectionPinMutation();

    const handleVerify = async () => {
        try {
            const result = await verifyPin({ code }).unwrap();
            setVerifiedPin(result);

            toast({
                status: "success",
                title: "PIN verified successfully",
            });
        } catch (error: any) {
            setVerifiedPin(null);
            toast({
                status: "error",
                title: "PIN verification failed",
                description: error?.data?.message || error?.message,
            });
        }
    };

    return (
        <Box p={6} maxW="520px">
            <Heading size="lg" mb={6}>
                Verify Collection Code
            </Heading>

            <VStack align="stretch" spacing={4}>
                <Input
                    placeholder="Enter collection code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                />

                <Button onClick={handleVerify} isLoading={isLoading}>
                    Verify Code
                </Button>

                {verifiedPin && (
                    <Box p={4} borderWidth="1px" rounded="md">
                        <Text>
                            <b>Client:</b> {verifiedPin.clientName || "-"}
                        </Text>
                        <Text>
                            <b>Phone:</b> {verifiedPin.clientPhone || "-"}
                        </Text>
                        <Text>
                            <b>Status:</b> {verifiedPin.status}
                        </Text>
                        <Text>
                            <b>Order:</b> {verifiedPin.orderId || "-"}
                        </Text>
                        <Text>
                            <b>Delivery:</b> {verifiedPin.deliveryId || "-"}
                        </Text>
                    </Box>
                )}
            </VStack>
        </Box>
    );
};

export default PinVerificationPage;